<template>
    <nav class="layoutFooter layoutRow layoutFooter">
      <div id="footerContent"></div>
    </nav>
</template>